import { render, staticRenderFns } from "./NameList.vue?vue&type=template&id=d56e3a18&scoped=true&"
import script from "./NameList.vue?vue&type=script&lang=js&"
export * from "./NameList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56e3a18",
  null
  
)

export default component.exports